import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SafetyImageCommentModal from "./safetyimgmodal";
const GlobalUploadModal = ({
  open,
  onClose,
  sectionOptions,
  questionOptions,
  onSubmit,
    setSelectedSection,
    selectedSection,
     setSelectedIndex
}) => {
//   const [selectedSection, setSelectedSection] = useState("");
  const [selectedQuestion, setSelectedQuestion] = useState("");

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white dark:bg-gray-900 w-full max-w-lg rounded-xl shadow-lg p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
            Add New Comment & Image
          </h2>
          <button
            onClick={()=>{
                setSelectedQuestion('')
                onClose()}}
            className="text-gray-500 hover:text-gray-700 dark:hover:text-white"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        {/* Section Selector */}
        <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1">
          Select Section
        </label>
        <select
          value={selectedSection}
          onChange={(e) => {
            setSelectedSection(e.target.value);
            setSelectedQuestion("");
          }}
          className="w-full mb-4 border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-800 dark:text-gray-100"
        >
          <option value="">-- Select Section --</option>
          {sectionOptions.map((sec) => (
            <option key={sec} value={sec}>
              {sec.replace(/([A-Z])/g, " $1")}
            </option>
          ))}
        </select>

        {/* Question Selector */}
        {selectedSection && (
          <>
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1">
              Select Question
            </label>
            <select
              value={selectedQuestion}
              onChange={(e) => {
                console.log(e.target.value)
                 setSelectedIndex(e.target.value)
                setSelectedQuestion(e.target.value)}}


              className="w-full mb-4 border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-800 dark:text-gray-100"
            >
              <option value="">-- Select Question --</option>
              {questionOptions[selectedSection]?.map((q, i) => (
                <option key={i} value={i}>
                  {q}
                </option>
              ))}
            </select>
          </>
        )}

        {/* Upload UI */}
        {selectedQuestion !== "" && (
          <SafetyImageCommentModal
            open={true}
            setSelectedQuestion={()=>setSelectedQuestion('')}
            onClose={onClose}
            onSubmit={(comment, files) =>{
              onSubmit(selectedSection, parseInt(selectedQuestion), comment, files)
              setSelectedQuestion('')
            }
            }
            loader={false}
          />
        )}
      </div>
    </div>
  );
};

export default GlobalUploadModal;
